import React, { Component } from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import s from './App.css';
import { Provider } from 'react-redux';
import ModalController from '../ModalController/connected';
import AccountWrapper from '../Account/AccountWrapper';
import ErrorBoundary from '../ErrorBoundary';
import { listenToBeforeInstallPrompt, listenToAppInstalled } from '../AddToHomeScreen/util';
import { withCookies, Cookies } from 'react-cookie';
import { keepAccessTokenRefreshed } from '../../core/auth';
import AuthenticationProvider from '../../core/login/AuthenticationProvider';
import ChatLoader from '../Chat/ChatLoader';
import TrackingPropertiesProvider from '../../core/tracking/TrackingPropertiesProvider';
import UpdateAppModal from './UpdateAppModal';
import ErrorPage from '../../routes/error/ErrorPage';

const ContextType = {
  insertCss: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired,
  setMeta: PropTypes.func.isRequired,
  ...Provider.childContextTypes,
};

class App extends Component {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.any.isRequired,
    error: PropTypes.object,
    cookies: instanceOf(Cookies).isRequired,
    route: PropTypes.object,
  };

  static childContextTypes = ContextType;

  getChildContext = () => this.props.context;

  componentWillMount = () => {
    const { insertCss } = this.props.context;
    this.removeCss = insertCss(s);
  };

  componentDidMount = () => {
    const { context, cookies } = this.props;
    listenToBeforeInstallPrompt();
    listenToAppInstalled();
    this.tokenRefreshId = keepAccessTokenRefreshed(context, cookies);
  };

  componentWillUnmount = () => {
    this.removeCss();
    window.clearInterval(this.tokenRefreshId);
  };

  render = () => {
    const { error, route } = this.props;
    if (error) {
      return <ErrorPage error={error} />;
    }

    const accountWrapperConfig = (route && route.accountWrapper) || {};
    const { loginRequired, returnAfterLogin, nonBlocking } = accountWrapperConfig;

    return (
      <ErrorBoundary fallbackUI={<ErrorPage />}>
        <AuthenticationProvider>
          <AccountWrapper
            loginRequired={loginRequired}
            returnAfterLogin={returnAfterLogin}
            nonBlocking={nonBlocking}
          >
            <TrackingPropertiesProvider>{this.props.children}</TrackingPropertiesProvider>
          </AccountWrapper>
          <ModalController />
          <ChatLoader />
        </AuthenticationProvider>
        <ErrorBoundary fallbackUI={null}>
          <UpdateAppModal />
        </ErrorBoundary>
      </ErrorBoundary>
    );
  };
}

export default withCookies(App);
